import {AiOutlineLinkedin} from 'react-icons/ai'
import { AiOutlineTwitter } from 'react-icons/ai'
import { AiFillGithub } from 'react-icons/ai'

const data = [
  {
    id: 1,
    link: "https://www.linkedin.com/in/bashir-aremu-880813aa/",
    icon: <AiOutlineLinkedin />,
  },
  { id: 2, link: "https://github.com/bashytech007", icon: <AiFillGithub /> },
  { id: 3, link: "https://twitter.com", icon: <AiOutlineTwitter /> },
];

export default data